import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
Vue.use(Router)

const routes = [

  {
    path: '/',
    name: 'RecruitIndex',
    component: () => import('@/views/index'),
    meta: {
      title: '首页',
      active: '首页'
    }
  },
  {
    path: '/search',
    name: 'RecruitSearch',
    component: () => import('@/views/search'),
    meta: {
      title: '搜索页',
      active: '搜索页'
    }
  },
  {
    path: '/list',
    name: 'RecruitList',
    component: () => import('@/views/list'),
    meta: {
      title: '社会招聘'
    }
  },
  {
    path: '/list/info',
    name: 'RecruitDetails',
    component: () => import('@/views/infoDetails'),
    meta: {
      title: '招聘详情',
      showSelectHead: {
        mobile: true
      }
    }
  },
  {
    path: '/list/resume',
    name: 'RecruitResume',
    component: () => import('@/views/resume'),
    meta: {
      title: '投递简历',
      showSelectHead: {
        mobile: true
      }
    }
  },
  {
    path: '/list/resume/:template',
    name: 'RecruitResumeType',
    component: () => import('@/views/resume/info'),
    meta: {
      title: '投递简历',
      showSelectHead: {
        mobile: true
      }
    }
  },
  // {
  //   path: '/about',
  //   name: 'RecruitAbout',
  //   component: () => import('@/views/about'),
  //   meta: {
  //     title: '了解金十',
  //     active: '了解金十'
  //   }
  // },
  {
    path: '/aboutDetails/:template',
    name: 'RecruitAboutDetails',
    component: () => import('@/views/aboutDetails'),
    meta: {
      title: '了解金十',
      active: '了解金十',
      showSelectHead: {
        mobile: true
      }
    }
  }
]

const router = new Router({
  routes: routes,
  // mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
